/**
 * useMealCount()
 * * This is a custom hook with helper functions to get recipes for a meal, selected recipe quantity and to check if the meal has all selections.
 */
const useMealCount = () => {
  const getRecipesForMeal = (recipes, meal, filterByRecipeType, recipeType) => {
    if (!meal) {
      return;
    }

    let recipesForMeal = recipes.filter((recipe) => recipe.ProgramMealId === meal.ProgramMealId);

    // Ensure its a valid recipe type before filtering. None/All recipe type will have an id of 0. 
    if (filterByRecipeType && recipeType?.id > 0) {
      recipesForMeal = recipesForMeal.filter((recipe) => {
        if (!!recipe.OffMenuRecipe) return true;
        return recipe.RecipeTypeNames.includes(recipeType?.name)
      });
    }

    return recipesForMeal;
  };

  const isMealQuantityFilled = (mealQuantity, recipes) => {
    if (mealQuantity > 0) {
      return Boolean(recipes.reduce((sum, recipe) => sum + recipe.Quantity, 0) >= mealQuantity);
    }
  };

  const getSelectedRecipeCount = (recipes) => {
    if (!recipes) {
      return;
    }

    return recipes.reduce((sum, recipe) => sum + recipe.Quantity, 0);
  };

  return {
    getRecipesForMeal,
    isMealQuantityFilled,
    getSelectedRecipeCount,
  };
};

export default useMealCount;
